(function() {
  function isMobile() {
    return window.matchMedia && window.matchMedia('(max-width: 749px)').matches;
  }

  function isCollectionPage() {
    return /^\/collections\//.test(window.location.pathname);
  }

  function isSingleCardCollectionUrl(url) {
    if (!url || !/^\/collections\//.test(url.pathname)) return false;
    var path = url.pathname.toLowerCase();
    if (/^\/collections\/products-/.test(path)) return false;
    if (path.indexOf('-products') !== -1) return false;
    if (path.indexOf('fu-ben') !== -1) return false;
    if (/^\/collections\/boardgame$/.test(path)) return false;
    if (/^\/collections\/sleeve-/.test(path)) return false;
    if (/^\/collections\/box-/.test(path)) return false;
    if (/^\/collections\/card-holder-/.test(path)) return false;
    if (/^\/collections\/portfolio-/.test(path)) return false;
    if (/^\/collections\/platmat-/.test(path)) return false;
    if (/^\/collections\/acc-/.test(path)) return false;
    if (/^\/collections\/%e5%8d%a1/.test(path)) return false;
    if (/^\/collections\/%e6%a1%8c%e5%a2%8a/.test(path)) return false;
    return true;
  }

  function mobileSingleUrl(rawHref) {
    var url;
    try {
      url = new URL(rawHref, window.location.origin);
    } catch (e) {
      return rawHref;
    }
    if (url.origin !== window.location.origin) return rawHref;
    if (!isSingleCardCollectionUrl(url)) return rawHref;
    url.searchParams.set('view', 'mobile-single');
    return url.pathname + url.search + url.hash;
  }

  function disableMobileFacebookFrame(root) {
    if (!isMobile()) return;
    root = root || document;

    root.querySelectorAll('[data-fb-page-wrapper]').forEach(function(wrapper) {
      if (wrapper.dataset.bgtcgMobileFallback === 'true') return;
      wrapper.dataset.bgtcgMobileFallback = 'true';
      wrapper.innerHTML = '<div class="fb-plugin-fallback">Facebook 動態未能載入。<br><a href="https://www.facebook.com/battleground.hk" target="_blank" rel="noopener noreferrer">開啟 Battleground Facebook 專頁</a></div>';
    });
  }

  var currentStock = 'all';
  var currentRarity = 'all';

  function setActiveButton(selector, activeValue, attrName) {
    document.querySelectorAll(selector).forEach(function(button) {
      button.classList.toggle('active', button.getAttribute(attrName) === activeValue);
    });
  }

  function restoreVisibleCards() {
    document.querySelectorAll('#ProductGridContainer .grid__item:not(.rarity-hidden):not(.stock-hidden)').forEach(function(item) {
      item.classList.remove('scroll-trigger--offscreen');
      item.style.removeProperty('opacity');
      item.style.removeProperty('transform');
      item.style.removeProperty('visibility');
    });
  }

  function applyTopFilters() {
    var flatItems = document.querySelectorAll('#ProductGridContainer .bgtcg-mobile-flat-grid .grid__item[data-rarity]');
    if (flatItems.length) {
      flatItems.forEach(function(item) {
        var rarity = item.getAttribute('data-rarity');
        var available = item.getAttribute('data-available');
        var rarityMatch = currentRarity === 'all' || currentRarity === rarity;
        var stockMatch = currentStock === 'all' ||
          (currentStock === 'in' && available === 'true') ||
          (currentStock === 'out' && available === 'false');

        item.classList.toggle('rarity-hidden', !rarityMatch);
        item.classList.toggle('stock-hidden', !stockMatch);
      });
      restoreVisibleCards();
    }
  }

  function handleTopFilterClick(event) {
    if (!isMobile()) return;

    var stockButton = event.target.closest && event.target.closest('#collectionTopFilter button[data-stock]');
    var rarityButton = event.target.closest && event.target.closest('#collectionTopFilter button[data-rarity]');
    var resetButton = event.target.closest && event.target.closest('#collectionTopFilter .filter-reset');
    if (!stockButton && !rarityButton && !resetButton) return;

    event.preventDefault();
    event.stopImmediatePropagation();

    if (stockButton) currentStock = stockButton.getAttribute('data-stock') || 'all';
    if (rarityButton) currentRarity = rarityButton.getAttribute('data-rarity') || 'all';
    if (resetButton) {
      currentStock = 'all';
      currentRarity = 'all';
    }

    setActiveButton('#collectionTopFilter button[data-stock]', currentStock, 'data-stock');
    setActiveButton('#collectionTopFilter button[data-rarity]', currentRarity, 'data-rarity');
    applyTopFilters();
  }

  function applyMobileSafeguards(root) {
    disableMobileFacebookFrame(root);
    if (!isMobile()) return;
    root = root || document;
    root.querySelectorAll('a[href*="/collections/"]').forEach(function(link) {
      var nextHref = mobileSingleUrl(link.getAttribute('href'));
      if (nextHref && nextHref !== link.getAttribute('href')) {
        link.setAttribute('href', nextHref);
      }
    });
  }

  function normalizeCurrentCollectionView() {
    return;
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      normalizeCurrentCollectionView();
      applyMobileSafeguards();
    });
  } else {
    normalizeCurrentCollectionView();
    applyMobileSafeguards();
  }

  document.addEventListener('click', handleTopFilterClick, true);

  document.addEventListener('click', function(event) {
    if (!isMobile()) return;
    var link = event.target.closest && event.target.closest('a[href*="/collections/"]');
    if (!link) return;
    var nextHref = mobileSingleUrl(link.getAttribute('href'));
    if (!nextHref || nextHref === link.getAttribute('href')) return;
    link.setAttribute('href', nextHref);
  }, true);

  if ('MutationObserver' in window) {
    new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        mutation.addedNodes.forEach(function(node) {
          if (node.nodeType === 1) applyMobileSafeguards(node);
        });
      });
    }).observe(document.documentElement, { childList: true, subtree: true });
  }

  window.__bgtcgMobileSafeEntry = {
    collectionPage: isCollectionPage(),
    redirectsDisabled: true
  };
})();
